import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { StringKeys } from '../../resources/strings/StringKeys';
import { SignalWifiConnectedNoInternet4 } from '@mui/icons-material';

const OfflineComponent = () => {
  const { t } = useTranslation();
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="80vh"
      bgcolor="background.default"
      padding={3}
    >
      <SignalWifiConnectedNoInternet4 sx={{ fontSize: 80, mb: 2 }} />
      <Typography variant="h6" align="center">
        {t(
          StringKeys.NO_INTERNET_CONNECTION_PLEASE_CHECK_YOUR_CONNECTION_AND_TRY_AGAIN,
        )}
      </Typography>
    </Box>
  );
};

export default OfflineComponent;
